"use strict";

var LoggerInstance = require("js-logger").get("SessionStorageHelper");

function getSessionStorageItem(key) {
	try {
		return sessionStorage.getItem(key);
	} catch (error) {
		LoggerInstance.warn("Unable to read sessionStorage item", { key, error });
		return null;
	}
}

function setSessionStorageItem(key, value) {
	try {
		sessionStorage.setItem(key, value);
		return true;
	} catch (error) {
		LoggerInstance.warn("Unable to write sessionStorage item", { key, error });
		return false;
	}
}

function removeSessionStorageItem(key) {
	try {
		sessionStorage.removeItem(key);
	} catch (error) {
		LoggerInstance.warn("Unable to remove sessionStorage item", { key, error });
	}
}

function tryParseJson(value) {
	if (!value) {
		return null;
	}

	try {
		return JSON.parse(value);
	} catch (error) {
		LoggerInstance.warn("Unable to parse cached JSON value", { error });
		return null;
	}
}

module.exports.getSessionStorageItem = getSessionStorageItem;
module.exports.setSessionStorageItem = setSessionStorageItem;
module.exports.removeSessionStorageItem = removeSessionStorageItem;
module.exports.tryParseJson = tryParseJson;
